const isTrue = (value) => value === 'true'

export const getInitialValues = (schema) => {
  const initialValues = {}
  schema.forEach((field) => {
    initialValues[field.attribute.name] = field.field === 'check' ? isTrue(field.defaultValue) : field.defaultValue
  })
  return initialValues
}
